"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralCompanyResponse = exports.ReferralCodeResponse = exports.DeleteCompanyUserRequestSchema = exports.UpdateCompanyUserRequestSchema = exports.CompanyRolesResponseSchema = exports.CompanyUsersResponse = exports.CompanyInvitation = exports.CompanyUser = exports.CompanyDetailsResponse = exports.UpdateCompanyLogoRequest = exports.UpdateCompanyRequest = exports.CompanyResponse = exports.CreateCompanyRequest = exports.tradeTypeLabelMap = exports.CompanyLicenseEntrySchema = exports.MAX_COMPANY_LICENSES = exports.TradeType = exports.CompanySize = exports.CompanyType = exports.NationalIdentifierType = void 0;
const zod_1 = require("zod");
const region_types_1 = require("./region.types");
var NationalIdentifierType;
(function (NationalIdentifierType) {
    NationalIdentifierType["ABN"] = "ABN";
    NationalIdentifierType["ACN"] = "ACN";
    NationalIdentifierType["NZBN"] = "NZBN";
    NationalIdentifierType["GST"] = "GST";
})(NationalIdentifierType || (exports.NationalIdentifierType = NationalIdentifierType = {}));
var CompanyType;
(function (CompanyType) {
    CompanyType["COMPANY"] = "COMPANY";
    CompanyType["SOLE_TRADER"] = "SOLE_TRADER";
})(CompanyType || (exports.CompanyType = CompanyType = {}));
var CompanySize;
(function (CompanySize) {
    CompanySize["SMALL"] = "SMALL";
    CompanySize["MEDIUM"] = "MEDIUM";
    CompanySize["BIG"] = "BIG";
})(CompanySize || (exports.CompanySize = CompanySize = {}));
var TradeType;
(function (TradeType) {
    TradeType["CONSTRUCTION_BUILDING"] = "CONSTRUCTION_BUILDING";
    TradeType["GLAZIERS"] = "GLAZIERS";
    TradeType["STEEL_FABRICATOR"] = "STEEL_FABRICATOR";
    TradeType["BRICKLAYERS_AND_STONEMASONS"] = "BRICKLAYERS_AND_STONEMASONS";
    TradeType["CARPENTERS_AND_JOINERS"] = "CARPENTERS_AND_JOINERS";
    TradeType["PAINTING"] = "PAINTING";
    TradeType["PLASTERERS"] = "PLASTERERS";
    TradeType["WALL_AND_FLOOR_TILERS"] = "WALL_AND_FLOOR_TILERS";
    TradeType["PLUMBERS"] = "PLUMBERS";
    TradeType["ELECTRICIANS"] = "ELECTRICIANS";
    TradeType["CABINETMAKERS"] = "CABINETMAKERS";
    TradeType["CLEANING"] = "CLEANING";
    TradeType["BLINDS_CURTAIN_INSTALLER"] = "BLINDS_CURTAIN_INSTALLER";
    TradeType["LANDSCAPING_MOWING"] = "LANDSCAPING_MOWING";
    TradeType["CONCRETER"] = "CONCRETER";
    TradeType["HOME_MAINTENANCE"] = "HOME_MAINTENANCE";
    TradeType["RESIDENTIAL_COMMERCIAL_FENCING"] = "RESIDENTIAL_COMMERCIAL_FENCING";
    TradeType["DOG_WASH"] = "DOG_WASH";
    TradeType["PEST_CONTROL"] = "PEST_CONTROL";
    TradeType["CARPET_CLEANING"] = "CARPET_CLEANING";
})(TradeType || (exports.TradeType = TradeType = {}));
exports.MAX_COMPANY_LICENSES = 2;
exports.CompanyLicenseEntrySchema = zod_1.z.object({
    name: zod_1.z.string().max(200),
    number: zod_1.z.string().max(200),
});
exports.tradeTypeLabelMap = {
    CONSTRUCTION_BUILDING: 'Construction / Building',
    GLAZIERS: 'Glaziers',
    STEEL_FABRICATOR: 'Steel Fabricator',
    BRICKLAYERS_AND_STONEMASONS: 'Bricklayers and Stonemasons',
    CARPENTERS_AND_JOINERS: 'Carpenters and Joiners',
    PAINTING: 'Painting',
    PLASTERERS: 'Plasterers',
    WALL_AND_FLOOR_TILERS: 'Wall and Floor Tilers',
    PLUMBERS: 'Plumbers',
    ELECTRICIANS: 'Electricians',
    CABINETMAKERS: 'Cabinetmakers',
    CLEANING: 'Cleaning',
    BLINDS_CURTAIN_INSTALLER: 'Blinds / Curtain Installer',
    LANDSCAPING_MOWING: 'Landscaping/Mowing',
    CONCRETER: 'Concreter',
    HOME_MAINTENANCE: 'Home Maintenance',
    RESIDENTIAL_COMMERCIAL_FENCING: 'Fencing',
    DOG_WASH: 'Dog Wash',
    PEST_CONTROL: 'Pest Control',
    CARPET_CLEANING: 'Carpet Cleaning',
};
exports.CreateCompanyRequest = zod_1.z.object({
    name: zod_1.z.string(),
    nationalIdentifier: zod_1.z.string(),
    nationalIdentifierType: zod_1.z.nativeEnum(NationalIdentifierType),
    companyType: zod_1.z.nativeEnum(CompanyType),
    companySize: zod_1.z.nativeEnum(CompanySize),
    tradeType: zod_1.z.nativeEnum(TradeType),
    registeredForTax: zod_1.z.boolean(),
    pricesIncludeTax: zod_1.z.boolean(),
    country: region_types_1.CountryCodeSchema.default(region_types_1.CountryCode.AU),
    referralCode: zod_1.z.string().optional(),
});
exports.CompanyResponse = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string(),
    }),
});
exports.UpdateCompanyRequest = zod_1.z.object({
    registeredForTax: zod_1.z.boolean(),
    pricesIncludeTax: zod_1.z.boolean(),
    bankDetails: zod_1.z
        .object({
        bankAccountName: zod_1.z.string(),
        bankAccountBSB: zod_1.z.string(),
        bankAccountNumber: zod_1.z.string(),
    })
        .optional(),
    licenses: zod_1.z.array(exports.CompanyLicenseEntrySchema).max(exports.MAX_COMPANY_LICENSES).optional(),
});
exports.UpdateCompanyLogoRequest = zod_1.z.object({
    logo: zod_1.z.string(),
});
exports.CompanyDetailsResponse = zod_1.z.object({
    data: zod_1.z.object({
        name: zod_1.z.string(),
        nationalIdentifier: zod_1.z.string(),
        nationalIdentifierType: zod_1.z.nativeEnum(NationalIdentifierType),
        companyType: zod_1.z.nativeEnum(CompanyType),
        companySize: zod_1.z.nativeEnum(CompanySize),
        tradeType: zod_1.z.nativeEnum(TradeType),
        logo: zod_1.z.string().optional(),
        registeredForTax: zod_1.z.boolean(),
        pricesIncludeTax: zod_1.z.boolean(),
        country: region_types_1.CountryCodeSchema,
        // Per-company feature flag: routes the "Add a canvas" entry to Canvas v2
        // (Skia). OFF by default; default(false) so a server predating the column
        // still parses. See DrawingCanvasV2.
        canvasV2: zod_1.z.boolean().default(false),
        referralCode: zod_1.z.string().nullable().optional(),
        bankDetails: zod_1.z
            .object({
            bankAccountName: zod_1.z.string(),
            bankAccountBSB: zod_1.z.string(),
            bankAccountNumber: zod_1.z.string(),
        })
            .optional(),
        licenses: zod_1.z.array(exports.CompanyLicenseEntrySchema).max(exports.MAX_COMPANY_LICENSES),
    }),
});
exports.CompanyUser = zod_1.z.object({
    id: zod_1.z.string(),
    email: zod_1.z.string(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    createdAt: zod_1.z.string().date(),
    enabled: zod_1.z.boolean(),
    userPermissionId: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    userPermissionName: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
});
exports.CompanyInvitation = zod_1.z.object({
    id: zod_1.z.string(),
    email: zod_1.z.string(),
    createdAt: zod_1.z.string().date(),
    userPermissionId: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    userPermissionName: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
});
exports.CompanyUsersResponse = zod_1.z.object({
    data: zod_1.z.object({
        users: zod_1.z.array(exports.CompanyUser),
        pendingUsers: zod_1.z.array(exports.CompanyInvitation),
        maxAccountUsers: zod_1.z.number().int().positive(),
    }),
});
exports.CompanyRolesResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        roles: zod_1.z.array(zod_1.z.object({
            id: zod_1.z.string(),
            name: zod_1.z.string(),
        })),
    }),
});
exports.UpdateCompanyUserRequestSchema = zod_1.z.object({
    userId: zod_1.z.string(),
    userPermissionId: zod_1.z.string(),
    enabled: zod_1.z.boolean().optional(),
});
exports.DeleteCompanyUserRequestSchema = zod_1.z.object({
    userId: zod_1.z.string(),
});
exports.ReferralCodeResponse = zod_1.z.object({
    data: zod_1.z.object({
        referralCode: zod_1.z.string(),
    }),
});
exports.ReferralCompanyResponse = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string(),
        name: zod_1.z.string(),
    }),
});
